import imageCompression from "browser-image-compression"
import { NewFileInput } from "../gql/graphql"
import config from "../config/config"

export const createFileFromBlob = (blob: Blob, filename: string) => {
  return new File([blob], filename, { type: blob.type })
}

const compressImage = async (file: File) => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  }
  return await imageCompression(file, options)
}

const handleUploadFile = ({
  file,
  getPrecent,
  cbError,
  cbOk,
}: {
  file: File
  getPrecent: (value: number) => void
  cbError: (err: any) => void
  cbOk: (file: NewFileInput) => void
}) => {
  if (!file) {
    alert("Veuiller choisir un fichier à télécharger")
    return
  }

  const formData = new FormData()
  formData.append("files", file, file.name)

  const xhr = new XMLHttpRequest()
  const baseUrl = config.isOnDev ? "http://localhost:3000" : config.REST_URL

  xhr.open("POST", `${baseUrl}/upload`)

  xhr.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      const percent = Math.round((event.loaded / event.total) * 100)
      getPrecent(percent)
    }
  }

  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      try {
        const response: Array<{
          name: string
          url: string
          type: string
          size: number
        }> = JSON.parse(xhr.responseText)

        const uploaded = response[0]
        if (uploaded) {
          cbOk({
            name: uploaded.name,
            type: uploaded.type,
            size: uploaded.size,
            url: uploaded.url,
          })
        }
      } catch {
        cbError(new Error("Erreur parsing réponse serveur"))
      }
    } else {
      cbError(new Error(`Erreur upload: ${xhr.status} ${xhr.statusText}`))
    }
  }

  xhr.onerror = () => cbError(new Error("Erreur réseau lors de l'upload"))
  xhr.ontimeout = () => cbError(new Error("Timeout lors de l'upload"))

  xhr.send(formData)
}

export const uploadFile = ({
  file,
  getPrecent,
  cbError,
  cbOk,
}: {
  file: File
  getPrecent: (value: number) => void
  cbError: (err: any) => void
  cbOk: (file: NewFileInput) => void
}) => {
  if (file.type.includes("image")) {
    compressImage(file)
      .then((compressedFile) => {
        handleUploadFile({ cbError, cbOk, file: compressedFile, getPrecent })
      })
      .catch((err) => cbError(err))
  } else {
    handleUploadFile({ cbError, cbOk, file, getPrecent })
  }
}
